import awkwardCricket from "./awkward_cricket.mp3";
import アレンジ from "./【8bitアレンジ】.mp3";
import disc from "./disc.svg";
import pause from "./pause.svg";
import play from "./play.svg";

export { awkwardCricket, アレンジ, disc, pause, play };

export default { awkwardCricket, アレンジ, disc, pause, play };
